export type { AuthActions, AuthGetters, AuthState, AuthStore } from './useAuth';
// Backward compatibility
export { useAuth, useAuth as useAuthState } from './useAuth';
